import React, { useState } from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import DOMPurify from "dompurify";

export default function AnswerPatternContent({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;
  const [selected, setSelected] = useState(-1);

  const handleNextButtonClick = () => {
    setSelected(-1);
    if (gameQuestionsQuery.content.length === currentQuestion + 1) {
      setCurrentQuestion(currentQuestion + 1);
      sendAnswers();
    } else {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const userAnswerString = answers
    .map((a) => a.answer_ident.toUpperCase())
    .join("");

  const matchedAnswer = gameQuestionsQuery.content[
    currentQuestion
  ].answers.find((answerObj) =>
    answerObj.answersNeeded.includes(userAnswerString),
  );

  return (
    <section className={`game-page quiz-mechanics ${ident}`}>
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(matchedAnswer.ident),
                }}
              />
            </div>
            <div className="main-content">
              <div className="based-content">
                {matchedAnswer && (
                  <p
                    className="based-copy"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(matchedAnswer.answer)}}
                  />
                )}

                {!matchedAnswer && (
                  <p className="based-copy">Nie udało się dopasować wyniku.</p>
                )}
              </div>
            </div>
            {matchedAnswer && (
              <p
                className="based-des"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(matchedAnswer.des)}}
              />
            )}
          </div>

          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            {gameQuestionsQuery.content[currentQuestion].desktopImgHid ? (
              selected ===
              gameQuestionsQuery.content[currentQuestion].correctAnswer ? (
                <img src={matchedAnswer.img} alt="" />
              ) : (
                <img src={matchedAnswer.img} alt="" />
              )
            ) : (
              <div className="img-wrapper">
                <img src={matchedAnswer.img} alt="" />
              </div>
            )}
            {XGA && (
              <StickyContent>
                <div className="desktop-buttons">
                  <Button disabled={false} action={handleNextButtonClick}>
                    {gameQuestionsQuery.content[currentQuestion]
                      .nextButtonCopy ?? "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>

      {!XGA && (
        <StickyButton disabled={false} action={handleNextButtonClick}>
          {gameQuestionsQuery.content[currentQuestion].nextButtonCopy ??
            "Nächste"}
        </StickyButton>
      )}
    </section>
  );
}
